<template>
    <div class="col-12 nopads">
        <top-bar
                @onSignInClicked="showLogin"
                @onSearchClicked="searchView"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
                @alertDismiss="alertDismiss"
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <login v-if="showLogIn"
                           @loginAdmin="showAdminView"
                           @loginUser="showCampaignView"
                           @alert="showAlert"
                           @close="showMain"
                           @resetClose="showNote">
                    </login>
                </transition>
                <div class="mx-auto ml-auto" v-if="!showLogIn">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs" />
                    <info-container class="mb-4"/>
                    <campaign-container
                            v-if="promotedCampaign && promotedCampaign > 0"
                            class="mb-3 mt-3"
                            :campaignId="parseInt(promotedCampaign)"
                    />
                    <category-feed @onCategorySet="setCategory"/>
                    <!--                    <b-container class="mb-4 pl-0 pr-0">
                                            <b-col lg="12" class="no-gutters">
                                                <h3 class="info-subtitle show-all-text palette-primary" @click.stop="showTeamsListView">{{$t("common.show_all")}}</h3>
                                                <h3>{{ $t("common.clubs_and_associations") }}</h3>
                                            </b-col>
                                        </b-container>-->
                    <!--                    <organization-feed />-->

                    <!--
                    <span v-if="category > 0" class="card-title pl-2">
                        {{ $t('common.nearby_teams') }}
                    </span>
                    <transition name="fade">
                        <team-feed
                                v-if="category > 0"
                                :category="category"/>
                    </transition>
                    <span class="card-title pl-2">
                        {{ $t('common.selected_for_you') }}
                    </span>
                    <campaign-feed :category="category"/>
                    -->
                    <payment-modal />
                </div>
            </div>
            <footer-area />
        </div>
    </div>

</template>

<script>
    import Login from "../components/Login";
    import Alert from '../components/Alert'
    import {alertMixin} from "@/mixins/AlertMixin";
    import {views} from "@/mixins/ViewMixin";
    import TopBar from "../components/TopBar";
    import CategoryFeed from "../components/feed/CategoryFeed";
    import InfoContainer from "@/components/info/InfoContainer";
    import FooterArea from "../components/FooterArea";
    import BreadCrumbs from "@/components/BreadCrumbs";
    import CampaignContainer from "@/components/campaign/CampaignContainer";
    import PaymentModal from "@/components/PaymentModal";

    export default {
        name: "main-view",
        mixins: [alertMixin, views],
        components: {CampaignContainer, CategoryFeed, BreadCrumbs, InfoContainer, FooterArea, TopBar, Alert, Login, PaymentModal},
        data() {
            return {
                showLogIn: false,
                showSearchField: false,
                category: -1,
                note: false,
                currentView: views.MAIN_VIEW,
                promotedCampaign: -1,
                breadcrumbs: [
                    {
                        text: "breadcrumbs.front_page",
                        translate: true,
                        route: 'main-view',
                        disabled: true,
                        active: true,
                    }
                ]
            }
        },

        created: function () {
            if (this.$store.state.token && this.$store.state.user) {
                this.showLogIn = false
                this.showAppropriateView()
            }
            this.promotedCampaign = process.env.VUE_APP_PROMO_CAMPAIGN_ID
        },

        methods: {
            searchView : function () {
                this.showLogIn = false
                this.$router.push({name: 'search-view'})
            },

            showLogin: function () {
                this.showLogIn = true
            },

            showMain: function () {
                this.showLogIn = false
            },

            showAdminView: function () {
                this.showLogIn = false
                if (!this.isSelectedView(views.ADMIN_VIEW)) {
                  this.$router.push({name: 'admin-view'})
                }
            },

            showCampaignView: function () {
                this.showLogIn = false
                if (!this.isSelectedView(views.MAIN_VIEW)) {
                  this.$router.push({name: 'main-view'})
                }
            },

            showTeamsListView: function () {
                this.showLogIn = false
                this.$router.push({name: 'teams-list-view'})
            },

            showAppropriateView: function () {
                if (this.$store.state.user.admin === true) {
                    this.showAdminView()
                } else {
                    this.showCampaignView()
                }
            },

            showNote: function () {
                this.note = true
                this.showAlert(this.$t('login.link_send'), "info")
            },

            alertDismiss: function () {
                if (this.note) {
                    this.showLogIn = false
                    this.note = false
                }
            },

            setCategory(category) {
                this.category = category
                this.$router.push({name: 'category-organizations-view', params: {id: category}})
            },

            isSelectedView: function (view) {
              return view === this.currentView
            },

            getMenuText() {
              switch (this.currentView)  {
                case views.CAMPAIGNS_VIEW: return this.$t('page.campaigns')
                case views.MY_DONATIONS_VIEW: return this.$t('common.my_donations')
              }
              return ''
            }
        }
    }
</script>

<style scoped>

</style>